/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-var */
// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
// import './index.css'
// import App from './App.tsx'

// createRoot(document.getElementById('root')!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// )

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// import { RouterProvider } from 'react-router-dom';
import { RouterProvider } from 'react-router/dom';

import AppRoute from './config/app-route.js';
// import { slideToggle } from './composables/slideToggle.js';

// bootstrap
import 'bootstrap';

// i18n
import './i18n';

// css
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './scss/styles.scss';

//redux
import { Provider } from 'react-redux'; //
import { store } from './store';
 
 

const container: any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={AppRoute} />
    </Provider>
  </StrictMode>
);

// function App() {
//   const element = useRoutes(AppRoute);
//   const location = useLocation();

//   // on every route change
//   React.useEffect(() => {
//     var elm = document.querySelector('.app');
//     if (elm) {
//       elm.classList.remove('app-sidebar-mobile-toggled');
//     }
//     var elm2: any = document.querySelector('.app-top-nav');
//     if (elm2 && elm2?.style.display === 'block') {
//       slideToggle(document.querySelector('.app-top-nav'));
//     }
//   }, [location]);

//   return element;
// }
